import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TombOfAkhenatenParsedGameData} from "../../server/data/TombOfAkhenatenParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TOAGameEvent} from "../../events/TOAGameEvent";
import {IBetWayWinData, IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Timeline, TimelineLite} from "gsap";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {TombOfAkhenatenGameConfig} from "../../TombOfAkhenatenGameConfig";
import {TombOfAkhenatenGameMode} from "../../gameMode/TombOfAkhenatenGameMode";
import {TombOfAkhenatenParsedInitData} from "../../server/data/TombOfAkhenatenParsedInitData";
import {TombOfAkhenatenReelController} from "../../reel/TombOfAkhenatenReelController";
import {SoundManager} from "../../sound/SoundManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TombOfAkhenaten} from "../../TombOfAkhenaten";

export class TOASymbolStateHandler {

    private _gameData: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData;
    private _symStates: boolean[] = [];
    private _winState: ISymbolStateConfig;
    private _noWinState: ISymbolStateConfig;
    private _semiDimmedState: ISymbolStateConfig;
    private _isBonusAnticipating: boolean = false;
    private _isAbort : boolean = false;
    private _symStateTl : TimelineLite;

    constructor() {
        this.addEventListeners();

        this._winState = TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win!;
        this._noWinState = TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin!;
        this._semiDimmedState = TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed!;
    }

    private static isFinalSpin(nextMode: string): boolean {
        let flag: boolean = false;
        if (nextMode === TombOfAkhenatenGameMode.NORMAL || nextMode === TombOfAkhenatenGameMode.FREESPIN) {
            flag = true;
        }
        return flag;
    }

    private changeStateOfX2OnWild(x2:PIXI.Sprite, state: ISymbolStateConfig){
        if(state.keyword == TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed.keyword){
            x2.tint = 0xadadad;
        }else if(state.keyword == TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.noWin.keyword){
            x2.tint = 0x555555;
        }else{
            x2.tint = 0xffffff;
        }
    }

    public changeStateOfSymbols(reelId: number, symbolId: number, state: ISymbolStateConfig): TimelineLite | null {
        const tl: TimelineLite = new TimelineLite();
        const symbol: StateReelSymbol | null = Reels.getSymbol(reelId, symbolId);
        if (symbol) {
            const symbolAnimation: Timeline = symbol.changeState({
                state: state,
                setStack: true,
                fadeInDuration: 0.0
            })!;

            tl.add([
                symbolAnimation,
            ]);
            // if(symbol.symName == "W"){
            //     const reelController = Reels.getReel(reelId);
            //     const sprite = (<TombOfAkhenatenReelController>reelController)._x2OnWild;
            //     if(sprite){
            //         tl.add(()=>this.changeStateOfX2OnWild(sprite, state));
            //     }
            // }
        }
        return tl;
    }

    private addEventListeners(): void {
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onDataParsed(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.SYM_STATE_HANDLER, (event: GameEvent) => this.handleSymStates(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.SYM_STATE_FIRE_GO_DARK, (event: GameEvent) => this.goDark(event.params[0]));
        EventHandler.addEventListener(this, TOAGameEvent.ON_NEW_GAME_ROUND, () => this.onSpinStart());
    }

    private onDataParsed(data: TombOfAkhenatenParsedGameData | TombOfAkhenatenParsedInitData): void {
        this._gameData = data;
        this._isAbort = false;
    }

    private handleSymStates(isAbort: boolean = false): void {
        this._isAbort = isAbort;
        if(this._symStateTl?.isActive()){
            this._symStateTl.pause().kill()
        }
        this._symStates = this.getSymbolStates();
        this._symStateTl = this.applySymbolState(this._symStates);
        if(isAbort){
            this._symStateTl.add(()=>{
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.UPDATE_MULTIPLIER, this._gameData.payoutMultiplierNextSpin, isAbort));
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ON_STONE_PRESS, this._gameData.activeRowsNextSpin, isAbort));
            });
            this._symStateTl.progress(1);
        }
    }

    private applySymbolState(winNoWin: boolean[]): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        let currentWinType: string = this.calculateWinType(),
            isBigWin: boolean = TombOfAkhenatenGameConfig.instance.BIG_WIN_TYPES.indexOf(currentWinType) > -1;

        if (TOASymbolStateHandler.isFinalSpin(this._gameData.nextMode)) {
            if(isBigWin){
                SoundManager.playBigWinInitialWinSound();
            }
            tl.add(() => {
                EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.REMOVE_SYM_STATE_FIRE))
            },0);
        }else{
            //#319, #304, #328
            if(!this._isAbort){
                if(isBigWin){
                    SoundManager.playBigWinBetWaySweepSound();
                } else {
                    // #437
                    if (TombOfAkhenaten.api.gameClientConfiguration.belowStakeWinRestriction) {
                        let betWaysWinningThisSpin: number = 0;
                        if (this._gameData.betWins) {
                            for (let i: number = 0; i < this._gameData.betWins.length; i++) {
                                betWaysWinningThisSpin += (<IBetWayWinData>this._gameData.betWins[i]).multipliedAmount;
                            }
                        }

                        if (betWaysWinningThisSpin > (this._gameData as TombOfAkhenatenParsedGameData).playedBetValue) {
                            SoundManager.playBetWaySweepSound(currentWinType);
                        }
                    } else {
                        SoundManager.playBetWaySweepSound(currentWinType);
                    }
                }
            }
        }
        for (let i: number = 0; i < winNoWin.length; i++) {
            if (!(winNoWin[i])) {
                //no win symbols
                tl.add(() => {
                    this.changeStateOfSymbols(i, 0, this._noWinState);
                },0);
            } else {
                //win & semiDimmed symbols
                if (TOASymbolStateHandler.isFinalSpin(this._gameData.nextMode)) {
                    tl.add(this.lockSymsLeftToRight(i, this._winState, true),0);
                } else {
                    tl.add(
                        this.lockSymsLeftToRight(i, TombOfAkhenatenReelController.SCATTER_COUNT > 1 ? this._semiDimmedState : TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal)
                    ,0);
                }
            }
        }
        return tl;
    }

    private getSymbolStates(): boolean[] {
        let currentBetWinData: IBetWinData[] | IBetWayWinData[] | undefined = this._gameData.betWins,
            currentSymStates: boolean[] = [];

        if (currentBetWinData) {
            for (let i: number = 0; i < currentBetWinData.length; i++) {
                let currentReelWinPositions: boolean[] = (currentBetWinData[i] as IBetWayWinData).reelWinPositions.reduce((acc, currEl) => acc.concat(<any>currEl), []);

                for (let j: number = 0; j < currentReelWinPositions.length; j++) {
                    if (!(currentSymStates[j])) {
                        currentSymStates[j] = currentReelWinPositions[j];
                    }
                }
            }
        } else {
            currentSymStates = new Array(TombOfAkhenatenGameConfig.instance.REELS_NUM).fill(false);
        }

        return currentSymStates;
    }

    private lockSymsLeftToRight(reelId: number, state: ISymbolStateConfig, isFinal: boolean = false): Timeline {
        let reelsArray = [[0, 1, 2, 3, 4], [5, 6, 7, 8, 9], [10, 11, 12, 13, 14], [15, 16, 17, 18, 19], [20, 21, 22, 23, 24]];

        const tl: TimelineLite = new TimelineLite();

        for (let i: number = 0; i < reelsArray.length; i++) {
            if (reelsArray[i].indexOf(reelId) > -1) {
                tl.add(() => {
                    if (this._gameData.nextMode.indexOf("FINAL") > -1) {
                        !isFinal && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ADD_SYM_STATE_FIRE, reelId, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword));
                    } else {
                        !isFinal && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ADD_SYM_STATE_FIRE, reelId, state.keyword));
                    }
                    //387
                    this.changeStateOfSymbols(reelId, 0, state);
                    if (state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.win.keyword) {
                        //this.changeStateOfSymbols(reelId, 0, state);
                        isFinal && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ADD_SYM_STATE_FIRE, reelId, state.keyword, true))
                    } else if (state.keyword === TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.normal.keyword) {
                        //this.changeStateOfSymbols(reelId, 0, state);
                        //sent semi dimmed state for normal case coz fire have only win and dimmed state.
                        !isFinal && EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.ADD_SYM_STATE_FIRE, reelId, TombOfAkhenatenGameConfig.instance.SYMBOL_STATES.semiDimmed.keyword))
                    }
                }, i * 0.1);
            }
        }
        return tl;
    }

    private goDark(flag: boolean): void {
        this._isBonusAnticipating = flag;
    }

    private onSpinStart(): void {
        this._isBonusAnticipating = false;
    }

    private calculateWinType(): string{
        let currentBetWinData: IBetWinData[] | IBetWayWinData[] | undefined = this._gameData.betWins,
            currentWinAmount: number = 0,
            currentBet: number = parseFloat(NolimitApplication.apiPlugin.betLevel.getLevel()),
            currentWinRatio: number = 0,
            defaultWinRatio = TombOfAkhenatenGameConfig.instance.DEFAULT_WIN_RATIOS,
            winType: string = "";

        if(currentBetWinData && currentBetWinData.length > 0){
            for(let i: number = 0; i < currentBetWinData.length; i++){
                currentWinAmount = currentWinAmount + currentBetWinData[i].multipliedAmount;
            }
        }

        currentWinRatio = currentWinAmount / currentBet;

        for(let i: number = 0; i < defaultWinRatio.length; i++){
            if(currentWinRatio >= defaultWinRatio[i].ratio){
                winType = defaultWinRatio[i].type;
            }else{
                break;
            }
        }
        return winType;
    }
}